import { combineReducers } from '@reduxjs/toolkit';

import timeoutAt from './timeoutAt';

/**
 * @typedef {{
 *  timeoutAt: import('./timeoutAt').TimeoutAtState,
 * }} WebSocketReducerState
 */

export default combineReducers({
  timeoutAt,
});
